export { Template } from "tsi-common-react/src/templates/LimitedTimeOfferGridBlockTemplate";
